
export const config = {
    level: 1,
    hitFromHeight: 4,
    minBeforeMiss: 5,
    missChanceStarting: 50,
    missChanceIncrement: 5,
    missChanceCap: 75,
    playerDistanceFromCenter: 7,
    playerDistanceFromNet: 16,
    
    minBeforeMissLevel:      [4,4,5,6,7], 
    missChanceStartingLevel: [50,40,35,30,25],
    missChanceCapLevel:      [75,65,60,55,50],
    smashChanceLevel:        [6 , 7 , 8 , 9, 10]
  };